<template>
  <a-modal
    :title="title"
    :width="modalWidth"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="头像" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-image-upload class="avatar-uploader" :isMultiple="true" :number="1"  :width="0" :height="0"  bizPath="avatar" v-decorator="[ 'avatar', validatorRules.avatar]" ></j-image-upload>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import Vue from 'vue'
  import { putAction } from '@/api/manage'
  import {  mapGetters } from 'vuex'
  import { USER_INFO} from "@/store/mutation-types"
  import pick from 'lodash.pick'
  export default {
    name: "UserHeadImg",
    data () {
      return {
        title:"修改头像",
        modalWidth:800,
        visible: false,
        confirmLoading: false,
        validatorRules:{
          avatar:{
            rules: [{
              required: true, message: '请上传头像!',
            }],
          }
        },
        confirmDirty:false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        form:this.$form.createForm(this),
        url: "sys/user/updateAvatar",
        model:{},
      }
    },
    methods: {
      ...mapGetters(["userInfo"]),
      edit(){
        this.model.avatar = this.userInfo().avatar;
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'avatar'))
        })
      },
      handleCancel () {
        this.close()
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
        this.selectedRole = [];
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let params = Object.assign(this.model, values);
            putAction(this.url,params).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.close();
                let userInfo = this.userInfo();
                userInfo.avatar = params.avatar
                Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
                that.$store.commit('SET_INFO', userInfo);
                console.log(this.userInfo())
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      }

    }
  }
</script>

<style scoped>

</style>

